module.exports = __webpack_public_path__ + "static/media/RUSH_logo.dd480b05.jpg";